import { event, $ } from "jquery";
import React, { Component } from "react";
import { NewAddressModal, ToolTip } from "../components/index";
import { CURRENCY, FORMAT_NUMBER, SYMBOL, noCreditGroupNumbers, ToolTips, Granel, Envasados } from "../libs/utils/Const";
import '../css/validations.css'

const RFC_FORMAT = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
const FULLNAME_FORMAT = /^[a-zA-ZÀ-ñÑ&'.,"\s\d-]{3,200}$/;
const ZIPCODE = /^\d{5,5}$/;
const CITY_FORMAT = /^[A-zA-z0-9-ñÑ&'.,\s]{4,100}$/;
const STREET_FORMAT = /^[A-Za-z0-9-ñÑ&'.,#\s]{4,100}$/;
const BLOCK_FORMAT = /^[A-zA-z0-9-ñÑ&'.,\s]{4,100}$/;
const PHONE_FORMAT = /^\d{10,10}$/;
const EMAIL_FORMAT = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
let errorInTapBill = false;

class DetailClientModal extends Component {

    componentDidMount() {
        const { ChanceTemporalDataToFalse } = this.props
        ChanceTemporalDataToFalse()
    }

    //#region ########## CHANGE FIELDS ##################################################
    refreshModel = (updatebusinessPartner) => {
        const { RefreshBusinessModel } = this.props;
        RefreshBusinessModel(updatebusinessPartner);
    };

    ChangeCardName = (value) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        if (value.length > 100) {
            updatebusinessPartner.CardName = value.substring(0, 100);
            updatebusinessPartner.U_FMB_AUX_CARDNAME = value;
            newOrderModel.CardName = value.substring(0, 100);
            newOrderModel.U_FMB_AUX_CARDNAME = value;
        } else {
            updatebusinessPartner.CardName = value;
            updatebusinessPartner.U_FMB_AUX_CARDNAME = '';
            newOrderModel.CardName = value;
            newOrderModel.U_FMB_AUX_CARDNAME = '';
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ValidateCardName = (action, lock) => {
        const { updatebusinessPartner, newOrderModel, showAlert } = this.props;

        if (updatebusinessPartner.CardName == "" || newOrderModel.CardName == "") {
            showAlert({ type: "error", message: `El nombre no puede ir vacio` });
            if (lock) {
                return;
            }
        }
        if (updatebusinessPartner.CardName.length > 100 || newOrderModel.CardName.length > 100) {
            showAlert({ type: "error", message: `El nombre debe ser de maximo 100 caracteres` });
            if (lock) {
                return;
            }
        }
        if (lock) {
            action();
        }
    }

    ValidateAddressList = async (action) => {
        const { DetailPartnerTools, showAlert, newOrderModel } = this.props
        if (DetailPartnerTools && DetailPartnerTools.deliveryAddresses.length === 0) {
            showAlert({ type: "error", message: `El cliente no tiene ninguna dirección de envío` });
            return;
        }
        if (DetailPartnerTools && DetailPartnerTools.billAddresses.length === 0) {
            showAlert({ type: "error", message: `El cliente no tiene ninguna dirección de facturación` });
            return;
        }
        if (DetailPartnerTools && DetailPartnerTools.setDeliveryIndex === "") {
            showAlert({ type: "error", message: `NO HAS SELECCIONADO UNA DIRECCIÓN DE ENVIÓ` });
            return;
        }
        if (DetailPartnerTools && DetailPartnerTools.setBillIndex === "") {
            showAlert({ type: "error", message: `NO HAS SELECCIONADO UNA DIRECCIÓN DE FACTURACIÓN` });
            return;
        }
        // Validate format UUID RELACIONADO
        if (newOrderModel.UUID_RELACIONADO && newOrderModel.UUID_RELACIONADO.trim() !== '') {
            const isValid = await this.ValidateOfUUIDRelation(newOrderModel.UUID_RELACIONADO);
            if (!isValid) {
                return;
            }
        }
        if (this.ValidateMethodPayment()) { return; }
        action();
    }

    ValidateLicTradNum = async () => {
        const { updatebusinessPartner } = this.props;
        let element = document.getElementById('rfc1');
        let icon = document.querySelector(`#grupo__rfc1 i`);
        let text = document.querySelector(`#grupo__rfc1 .form__input-error`);
        let require = document.querySelector(`#grupo__rfc1 .form__input-void`);
        if (!updatebusinessPartner.LicTradNum == '') {
            if (!RFC_FORMAT.test(updatebusinessPartner.LicTradNum)) {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.add('fa-times-circle');
                icon.classList.add('form__group-incorrect');
                icon.classList.remove('fa-check-circle');
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
                return
            } else {
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                icon.classList.add('fa-check-circle');
                icon.classList.add('form__group-correct');
                icon.classList.remove('fa-times-circle');
                icon.classList.remove('form__group-incorrect');
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        } else {
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");
            icon.classList.remove('fa-check-circle');
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
            return
        }
        return true
    }

    ValidateFullName = async () => {
        const { updatebusinessPartner } = this.props;

        let element = document.getElementById('fullName');
        let icon = document.querySelector(`#grupo__fullName i`);
        let text = document.querySelector(`#grupo__fullName .form__input-error`);
        let require = document.querySelector(`#grupo__fullName .form__input-void`);
        if (!updatebusinessPartner.CardName == '') {
            if (!FULLNAME_FORMAT.test(updatebusinessPartner.CardName)) {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.add('fa-times-circle');
                icon.classList.add('form__group-incorrect');
                icon.classList.remove('fa-check-circle');
                text.classList.add('form__input-error-active');
                require.classList.remove('form__input-void-active');
                return
            } else {
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                icon.classList.add('fa-check-circle');
                icon.classList.add('form__group-correct');
                icon.classList.remove('fa-times-circle');
                icon.classList.remove('form__group-incorrect');
                text.classList.remove('form__input-error-active');
                require.classList.remove('form__input-void-active');
            }
        } else {
            element.classList.add('form__group-incorrect');
            element.classList.remove("form__group-correct");
            icon.classList.remove('fa-check-circle');
            require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
            return
        }
        return true
    }

    ValidatePhone = async () => {
        const { updatebusinessPartner } = this.props;
        let text = document.querySelector(`#grupo__phone1 .form__input-error`);
        if (!updatebusinessPartner.Cellular == '') {
            if (!PHONE_FORMAT.test(updatebusinessPartner.Cellular)) {
                text.classList.add('form__input-error-active');
                return
            } else {
                text.classList.remove('form__input-error-active');
            }
        } else {
            text.classList.remove('form__input-error-active');
            return
        }
        return true
    }

    ValidateEmail = async () => {
        const { updatebusinessPartner } = this.props;
        let text = document.querySelector(`#grupo__emailC .form__input-error`);
        if (!updatebusinessPartner.E_mail == '') {
            if (!EMAIL_FORMAT.test(updatebusinessPartner.E_mail)) {
                text.classList.add('form__input-error-active');
                return
            } else {
                text.classList.remove('form__input-error-active');
            }
        } else {
            text.classList.remove('form__input-error-active');
            return
        }
        return true
    }

    ValidateUCFDI = async () => {
        const { newOrderModel } = this.props;
        // console.log('job', newOrderModel.USOCFDI)
        // let element = document.getElementById('selectProject');
        // let require = document.querySelector(`#grupo__selectProject .form__input-void`);
        let text = document.querySelector(`#grupo__selectProject1 .form__input-error`);

        if (newOrderModel.USOCFDI == '' || newOrderModel.USOCFDI == '---') {
            // element.classList.remove('form__group-incorrect');
            // element.classList.add("form__group-correct");
            text.classList.add('form__input-error-active');
            // require.classList.remove('form__input-void-active');
        } else {
            // element.classList.add('form__group-incorrect');
            // element.classList.remove("form__group-correct");           
            // require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
            return
        }
        return true
    }

    ValidateTaxSystem = async () => {
        const { newOrderModel } = this.props;
        // let element = document.getElementById('selectProject');
        // let require = document.querySelector(`#grupo__selectProject .form__input-void`);
        let text = document.querySelector(`#grupo__taxSystem .form__input-error`);

        if (newOrderModel.RegimenFiscal == '' || newOrderModel.RegimenFiscal == '---') {
            // element.classList.remove('form__group-incorrect');
            // element.classList.add("form__group-correct");
            text.classList.add('form__input-error-active');
            // require.classList.remove('form__input-void-active');
        } else {
            // element.classList.add('form__group-incorrect');
            // element.classList.remove("form__group-correct");           
            // require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
            return
        }
        return true
    }


    ValidateTypeOfRelation = async () => {
        const { newOrderModel } = this.props;
        // let element = document.getElementById('selectProject');
        // let require = document.querySelector(`#grupo__selectProject .form__input-void`);
        let text = document.querySelector(`#grupo__typeOfRelation .form__input-error`);

        if (newOrderModel.U_FMB_TIPO_REL == '' || newOrderModel.U_FMB_TIPO_REL == '00') {
            // element.classList.remove('form__group-incorrect');
            // element.classList.add("form__group-correct");
            text.classList.add('form__input-error-active');
            // require.classList.remove('form__input-void-active');
        } else {
            // element.classList.add('form__group-incorrect');
            // element.classList.remove("form__group-correct");           
            // require.classList.add('form__input-void-active');
            text.classList.remove('form__input-error-active');
            return
        }
        return true
    }

    ValidateOfUUIDRelation = async (uuid) => {
        const { showAlert } = this.props;
        const uuidRegex = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/;

        if (!uuidRegex.test(uuid)) {
            showAlert({ type: "error", message: `El UUID RELACIONADO no tiene un formato válido` });
            return false;
        }
        return true
    }

    ValidateZipCodeShip = async () => {
        const { newOrderModel, showTemporalData } = this.props;
        let element = document.getElementById('pc1');
        let icon = document.querySelector(`#grupo__pc1 i`);
        let text = document.querySelector(`#grupo__pc1 .form__input-error`);
        let require = document.querySelector(`#grupo__pc1 .form__input-void`);
        if (false) {
            if (!newOrderModel.AddressExtension.ShipToZipCode == "") {
                if (!ZIPCODE.test(newOrderModel.AddressExtension.ShipToZipCode)) {
                    element.classList.add('form__group-incorrect');
                    element.classList.remove("form__group-correct");
                    icon.classList.add('fa-times-circle');
                    icon.classList.add('form__group-incorrect');
                    icon.classList.remove('fa-check-circle');
                    text.classList.add('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                    errorInTapBill = true
                    this.forceUpdate();
                    return
                } else {
                    element.classList.remove('form__group-incorrect');
                    element.classList.add("form__group-correct");
                    icon.classList.add('fa-check-circle');
                    icon.classList.add('form__group-correct');
                    icon.classList.remove('fa-times-circle');
                    icon.classList.remove('form__group-incorrect');
                    text.classList.remove('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                }
            } else {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.remove('fa-check-circle');
                require.classList.add('form__input-void-active');
                text.classList.remove('form__input-error-active');
                errorInTapBill = true
                this.forceUpdate();
                return
            }
        }
        return true
    }

    ValidateStreet = async () => {
        const { newOrderModel, showTemporalData } = this.props;
        let element = document.getElementById('street2');
        let icon = document.querySelector(`#grupo__street2 i`);
        let text = document.querySelector(`#grupo__street2 .form__input-error`);
        let require = document.querySelector(`#grupo__street2 .form__input-void`);
        if (showTemporalData) {
            if (!newOrderModel.AddressExtension.BillToStreet == "") {
                if (!STREET_FORMAT.test(newOrderModel.AddressExtension.BillToStreet)) {
                    element.classList.add('form__group-incorrect');
                    element.classList.remove("form__group-correct");
                    icon.classList.add('fa-times-circle');
                    icon.classList.add('form__group-incorrect');
                    icon.classList.remove('fa-check-circle');
                    text.classList.add('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                    errorInTapBill = true
                    this.forceUpdate();
                    return
                } else {
                    element.classList.remove('form__group-incorrect');
                    element.classList.add("form__group-correct");
                    icon.classList.add('fa-check-circle');
                    icon.classList.add('form__group-correct');
                    icon.classList.remove('fa-times-circle');
                    icon.classList.remove('form__group-incorrect');
                    text.classList.remove('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                }
            } else {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.remove('fa-check-circle');
                require.classList.add('form__input-void-active');
                text.classList.remove('form__input-error-active');
                errorInTapBill = true
                this.forceUpdate();
                return
            }
        }
        return true
    }

    ValidateBlock = async () => {
        const { newOrderModel, showTemporalData } = this.props;
        let element = document.getElementById('block2');
        let icon = document.querySelector(`#grupo__block2 i`);
        let text = document.querySelector(`#grupo__block2 .form__input-error`);
        let require = document.querySelector(`#grupo__block2 .form__input-void`);
        if (showTemporalData) {
            if (!newOrderModel.AddressExtension.BillToBlock == "") {
                if (!BLOCK_FORMAT.test(newOrderModel.AddressExtension.BillToBlock)) {
                    element.classList.add('form__group-incorrect');
                    element.classList.remove("form__group-correct");
                    icon.classList.add('fa-times-circle');
                    icon.classList.add('form__group-incorrect');
                    icon.classList.remove('fa-check-circle');
                    text.classList.add('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                    errorInTapBill = true
                    this.forceUpdate();
                    return
                } else {
                    element.classList.remove('form__group-incorrect');
                    element.classList.add("form__group-correct");
                    icon.classList.add('fa-check-circle');
                    icon.classList.add('form__group-correct');
                    icon.classList.remove('fa-times-circle');
                    icon.classList.remove('form__group-incorrect');
                    text.classList.remove('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                }
            } else {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.remove('fa-check-circle');
                require.classList.add('form__input-void-active');
                text.classList.remove('form__input-error-active');
                errorInTapBill = true
                this.forceUpdate();
                return
            }
        }
        return true
    }

    ValidateCity = async () => {
        const { newOrderModel, showTemporalData, showAlert } = this.props;
        let element = document.getElementById('city2');
        let icon = document.querySelector(`#grupo__city2 i`);
        let text = document.querySelector(`#grupo__city2 .form__input-error`);
        let require = document.querySelector(`#grupo__city2 .form__input-void`);
        if (showTemporalData) {
            if (!newOrderModel.AddressExtension.BillToCity == "") {
                if (!CITY_FORMAT.test(newOrderModel.AddressExtension.BillToCity)) {
                    element.classList.add('form__group-incorrect');
                    element.classList.remove("form__group-correct");
                    icon.classList.add('fa-times-circle');
                    icon.classList.add('form__group-incorrect');
                    icon.classList.remove('fa-check-circle');
                    text.classList.add('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                    errorInTapBill = true
                    this.forceUpdate();
                    return
                } else {
                    element.classList.remove('form__group-incorrect');
                    element.classList.add("form__group-correct");
                    icon.classList.add('fa-check-circle');
                    icon.classList.add('form__group-correct');
                    icon.classList.remove('fa-times-circle');
                    icon.classList.remove('form__group-incorrect');
                    text.classList.remove('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                    // errorInTapBill=false
                    // this.forceUpdate();
                }
            } else {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.remove('fa-check-circle');
                require.classList.add('form__input-void-active');
                text.classList.remove('form__input-error-active');
                errorInTapBill = true
                this.forceUpdate();
                return
            }
        }
        return true
    }

    ValidateZipCodeBill = async () => {
        const { newOrderModel, showTemporalData, showAlert } = this.props;
        let element = document.getElementById('pc2');
        let icon = document.querySelector(`#grupo__pc2 i`);
        let text = document.querySelector(`#grupo__pc2 .form__input-error`);
        let require = document.querySelector(`#grupo__pc2 .form__input-void`);
        if (showTemporalData) {
            if (!newOrderModel.AddressExtension.BillToZipCode == "") {
                if (!ZIPCODE.test(newOrderModel.AddressExtension.BillToZipCode)) {
                    element.classList.add('form__group-incorrect');
                    element.classList.remove("form__group-correct");
                    icon.classList.add('fa-times-circle');
                    icon.classList.add('form__group-incorrect');
                    icon.classList.remove('fa-check-circle');
                    text.classList.add('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                    // errorInTapBill=true
                    // this.forceUpdate();
                    return
                } else {
                    element.classList.remove('form__group-incorrect');
                    element.classList.add("form__group-correct");
                    icon.classList.add('fa-check-circle');
                    icon.classList.add('form__group-correct');
                    icon.classList.remove('fa-times-circle');
                    icon.classList.remove('form__group-incorrect');
                    text.classList.remove('form__input-error-active');
                    require.classList.remove('form__input-void-active');
                    // errorInTapBill=false
                    // this.forceUpdate();
                }
            } else {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                icon.classList.remove('fa-check-circle');
                require.classList.add('form__input-void-active');
                text.classList.remove('form__input-error-active');
                errorInTapBill = true
                this.forceUpdate();
                return
            }
        }
        return true
    }

    ValidateCreditLine = (nextStep = false) => {
        const { updatebusinessPartner, GroupNumList, showAlert } = this.props;
        const creditLine = Number(updatebusinessPartner?.CreditLine ?? '0');
        const GroupName = GroupNumList.find(({ GroupNum }) => Number(GroupNum) === Number(updatebusinessPartner.GroupNum))?.PymntGroup ?? undefined;
        const creditCondition = noCreditGroupNumbers.find((GroupNum) => GroupNum === Number(updatebusinessPartner.GroupNum));

        if (!nextStep) { this.ChangeCreditLine(creditLine.toFixed(2)); }
        if (!creditCondition && creditLine <= 0) {
            showAlert({ type: nextStep ? "warning" : "info", message: `La condición de pago "${GroupName}" requiere que el campo "Crédito" sea mayor a 0.00` });
            return true;
        }
        return false;
    }

    ValidateMethodPayment = () => {
        const { newOrderModel, showAlert } = this.props;
        if (newOrderModel.U_SO1_02METODOPAGO && newOrderModel.U_SO1_02METODOPAGO !== '') {
            if (newOrderModel.U_SO1_02METODOPAGO && newOrderModel.U_SO1_02FORMAPAGO !== '') {
                if (newOrderModel.U_SO1_02METODOPAGO === 'PUE' && newOrderModel.U_SO1_02FORMAPAGO === '99') {
                    showAlert({ type: "info", message: `El método "Pago en una exhibición" no puede ir con la forma de pago "Por definir"` });
                    return true;
                } else if (newOrderModel.U_SO1_02METODOPAGO === 'PPD' && newOrderModel.U_SO1_02FORMAPAGO !== '99') {
                    showAlert({ type: "info", message: `El método "Pago en parcialidades o diferido" solo puede ir con la forma de pago "Por definir"` });
                    return true;
                }
            }
            else {
                showAlert({ type: "warning", message: `Seleccione un método de pago valido` });
                return true;
            }
        }
        return false;
    }

    ValidateState = async () => {
        const { newOrderModel, showTemporalData } = this.props;
        let element = document.getElementById('state2');
        let require = document.querySelector(`#grupo__state2 .form__input-void`);
        if (showTemporalData) {
            if (newOrderModel.AddressExtension.BillToCounty != '' && newOrderModel.AddressExtension.BillToCounty != '---') {
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                require.classList.remove('form__input-void-active');
            } else {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                require.classList.add('form__input-void-active');
                errorInTapBill = true
                return
            }
        }
        return true
    }

    ValidateState = async () => {
        const { newOrderModel, showTemporalData } = this.props;
        let element = document.getElementById('state2');
        let require = document.querySelector(`#grupo__state2 .form__input-void`);
        if (showTemporalData) {
            if (newOrderModel.AddressExtension.BillToCounty != '' && newOrderModel.AddressExtension.BillToCounty != '---') {
                element.classList.remove('form__group-incorrect');
                element.classList.add("form__group-correct");
                require.classList.remove('form__input-void-active');
            } else {
                element.classList.add('form__group-incorrect');
                element.classList.remove("form__group-correct");
                require.classList.add('form__input-void-active');
                errorInTapBill = true
                return
            }
        }
        return true
    }


    ValidateShipToDef_And_BillToDef_IfItNeeded = async () => {
        const { showTemporalData, DetailPartnerTools, showAlert } = this.props;
        if (!showTemporalData) {
            if (DetailPartnerTools.setDeliveryIndex && DetailPartnerTools.setDeliveryIndex === '') {
                showAlert({ type: "error", message: `No has seleccionado una dirección de envió` });
                return false;
            }
            if ((DetailPartnerTools.setBillIndex && DetailPartnerTools.setBillIndex === '')) {
                showAlert({ type: "error", message: `No has seleccionado una dirección de facturación` });
                return false;
            }
        }
        return true
    }

    ValidateAll = async (action, lock) => {
        const { showAlert } = this.props;
        this.ChangeAddressCountry("MX")
        this.ValidateStreet()
        this.ValidateBlock()
        this.ValidateCity()
        this.ValidateZipCodeBill()
        this.ValidateState()
        this.ValidateCity()

        if (this.ValidateCreditLine(true)) { return; }
        if (this.ValidateMethodPayment()) { return; }
        if (errorInTapBill) {
            showAlert({ type: "warning", message: `Faltan datos en la dirección de facturación` });
        }
        if (await this.ValidateLicTradNum() === true && await this.ValidateFullName() == true && await this.ValidateZipCodeShip() == true && await this.ValidateStreet() == true && await this.ValidateBlock() == true && await this.ValidateCity() == true && await this.ValidateZipCodeBill() == true && await this.ValidateState() == true && await this.ValidateShipToDef_And_BillToDef_IfItNeeded() === true && lock == true) {
            errorInTapBill = false
            action();
        }
    }

    ResetValidations = async (action) => {
        const { showTemporalData } = this.props
        const ids = [
            'fullName',
            'rfc1',
            'pc1',
            'pc2',
            'street2',
            'block2',
            'city2',
            'state2',
        ];
        const ids2 = [
            'emailC',
            'phone1'
        ];

        for (let index = 0; index < ids.length; index++) {
            if (showTemporalData !== true && (ids[index] == 'pc1' || ids[index] == 'pc2' || ids[index] == 'street2' || ids[index] == 'block2' || ids[index] == 'city2' || ids[index] == 'state2')) {

            }
            else {
                let element = document.getElementById(ids[index]);
                let icon = document.querySelector(`#grupo__` + ids[index] + ` i`);
                let text = document.querySelector(`#grupo__` + ids[index] + ` .form__input-error`);
                let require = document.querySelector(`#grupo__` + ids[index] + ` .form__input-void`);
                element.classList.remove("form__group-correct");
                element.classList.remove('form__group-incorrect');
                if (ids[index] != 'groupClient' && ids[index] != 'priceList' && ids[index] != 'state2') {
                    icon.classList.remove('fa-check-circle');
                    icon.classList.remove('fa-times-circle');
                    text.classList.remove('form__input-error-active');
                }
                require.classList.remove('form__input-void-active');
            }
        }
        for (let index = 0; index < ids2.length; index++) {
            let text = document.querySelector(`#grupo__` + ids2[index] + ` .form__input-error`);
            text.classList.remove('form__input-error-active');
        }
        errorInTapBill = false
        action();
    }

    ChangeCellular = (value) => {
        const { updatebusinessPartner } = this.props;
        if (isNaN(value) == false && value.length <= 10) {
            updatebusinessPartner.Cellular = value;
            this.refreshModel(updatebusinessPartner);
        }
    };

    ChangeCreditLine = (value) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        if (!isNaN(value)) {
            updatebusinessPartner.CreditLine = value;
            this.refreshModel(updatebusinessPartner);

            newOrderModel.CreditLine = value;
            refreshModel(newOrderModel);
        }
    };

    ChangeExtraDays = (value) => {
        const { updatebusinessPartner } = this.props;
        updatebusinessPartner.ExtraDays = value.nativeEvent.target.value;
        this.refreshModel(updatebusinessPartner);
    };

    ChangeE_mail = (value) => {
        const { updatebusinessPartner } = this.props;
        updatebusinessPartner.E_mail = value;
        this.refreshModel(updatebusinessPartner);
    };

    ChangeGroupNum = (value) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        updatebusinessPartner.GroupNum = value;
        newOrderModel.GroupNum = value;
        refreshModel(newOrderModel);
        this.refreshModel(updatebusinessPartner);
        this.ValidateCreditLine();
    };

    ChangeLicTradNum = (value) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        updatebusinessPartner.LicTradNum = value;
        newOrderModel.LicTradNum = value;
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeDownPaymentPercentage = (value) => {
        const { newOrderModel, showAlert, RefreshOrder } = this.props;
        newOrderModel.TotalCopy = newOrderModel.Total;
        if (isNaN(value)) {
            showAlert({ type: "error", message: `Inserta un valor valido.` });
            return;
        }
        if (Number(value) >= 101) {
            showAlert({
                type: "info",
                message: `Solo puede asignar un valor menor igual a 100`,
            });
            return;
        }
        if (Number(value) === 0 || value === "" || value.length === 0) {
            newOrderModel.Total = newOrderModel.TotalCopy;
            RefreshOrder(newOrderModel);
            this.RecalculateFinalPriceDoc();
        }

        newOrderModel.DownPaymentPercentage = value;
        newOrderModel.DownPayment = value;

        RefreshOrder(newOrderModel);

        this.RecalculateFinalPriceDoc();
    };
    //#endregion

    //#region ########## CHANGE FIELDS ADDRESSES ##################################################
    ChangeAddressStreet = (value, pointer) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        if (pointer === "S") {
            newOrderModel.AddressExtension.ShipToStreet = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToStreet = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeAddressBlock = (value, pointer) => {
        const { updatebusinessPartner, refreshModel, newOrderModel } = this.props;
        if (pointer === "S") {
            newOrderModel.AddressExtension.ShipToBlock = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToBlock = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeAddressCity = (value, pointer) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        if (pointer === "S") {
            newOrderModel.AddressExtension.ShipToCity = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToCity = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeAddressZipCode = (value, pointer) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        if (pointer === "S") {
            newOrderModel.AddressExtension.ShipToZipCode = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToZipCode = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeAddressCounty = (value, pointer) => {
        const { updatebusinessPartner, newOrderModel, refreshModel } = this.props;
        if (pointer === "S") {
            newOrderModel.AddressExtension.ShipToCounty = value;
            newOrderModel.AddressExtension.ShipToState = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToCounty = value;
            newOrderModel.AddressExtension.BillToState = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    ChangeAddressCountry = (value, pointer) => {
        const { newOrderModel, updatebusinessPartner, refreshModel } = this.props;
        if (pointer === "S") {
            newOrderModel.AddressExtension.ShipToCountry = value;
        } else if (pointer === "B") {
            newOrderModel.AddressExtension.BillToCountry = value;
        }
        this.refreshModel(updatebusinessPartner);
        refreshModel(newOrderModel);
    };

    EqualsShipToBillAddress = () => {
        const { updatebusinessPartner } = this.props;
        updatebusinessPartner.billAddress.Street =
            updatebusinessPartner.shipAddress.Street;
        updatebusinessPartner.billAddress.Block =
            updatebusinessPartner.shipAddress.Block;
        updatebusinessPartner.billAddress.City =
            updatebusinessPartner.shipAddress.City;
        updatebusinessPartner.billAddress.ZipCode =
            updatebusinessPartner.shipAddress.ZipCode;
        updatebusinessPartner.billAddress.County =
            updatebusinessPartner.shipAddress.County;
        updatebusinessPartner.billAddress.Country =
            updatebusinessPartner.shipAddress.Country;

        // updatebusinessPartner.billAddress = updatebusinessPartner.shipAddress;
        this.refreshModel(updatebusinessPartner);
    };

    //#endregion

    ChangeShowWithStock = async () => {
        await this.setState({
            ShowWithStock: !this.state.ShowWithStock
        })
    }

    ChangeU_FMB_UUID_RELACIONADO = async value => {
        const { refreshModel, newOrderModel } = this.props;
        newOrderModel.U_FMB_UUID_RELACIONADO = value
        refreshModel(newOrderModel);
    }

    render() {
        const {
            EditBusinessPartner,
            editMode,
            UpdateBusinessPartner,
            updatebusinessPartner,
            DetailPartnerTools,
            NextStepFunction,
            GroupNumList,
            actionButton,
            CanChangePartner,
            ShowClientsModalReBilling,
            CFDI,
            RegimenFiscal,
            ChangeUSOCFDI,
            ChangeRegimenFiscal,
            Change_MetodoPago,
            Change_FormaPago,
            Change_Tipo_Relacion_CFDI,
            newOrderModel,
            ContinueWithoutSave,
            ChangeShowTemporalData,
            states,
            showTemporalData,
            countries,
            view,
            RecoverDoc,
            changeOrderField,
            prioridadVtaCatalog,
            ChangeOfUUIDRelation,
        } = this.props;

        const creditCondition = noCreditGroupNumbers.find((GroupNum) => GroupNum === Number(newOrderModel.GroupNum));
        if (newOrderModel.AddressExtension && states.length > 0) { // Seleccionar los estados correctos al usar AddressExtension
            newOrderModel.AddressExtension.ShipToState = states.find(({ Code, Name }) => newOrderModel.AddressExtension.ShipToState === Code || newOrderModel.AddressExtension.ShipToState === Name)?.Code ?? '';
            newOrderModel.AddressExtension.BillToState = states.find(({ Code, Name }) => newOrderModel.AddressExtension.BillToState === Code || newOrderModel.AddressExtension.BillToState === Name)?.Code ?? '';
        }
        const showPrioridadVta = (newOrderModel.ObjType !== "downPayments" && newOrderModel.ObjType !== "deliveries4" && newOrderModel.ObjType !== "quotations");
        return (
            <div>
                <div className="modal fade" id="detailClientModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="detailClientModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="container" id="advanced-search-form">
                                    <div className="row">
                                        <div className="col-md-6 text-left mt-2">
                                            <h4>Datos del cliente</h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            {!!CanChangePartner && CanChangePartner === true && (
                                                <button className="btn btn-primary mt-2" style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right", }} onClick={!!ShowClientsModalReBilling && ShowClientsModalReBilling}>
                                                    <i className="fa fa-address-book-o" aria-hidden="true" />
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    <form>
                                        <div className="row">
                                            <div className="form-group mt-4  col-6">
                                                <label htmlFor="first-name">Código</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Código"
                                                    id="clientCode"
                                                    disabled={true}
                                                    value={updatebusinessPartner.CardCode || ""}
                                                />
                                            </div>
                                            <div className="mt-4  col-6">
                                                <div className="form-group formulario__grupo" id="grupo__rfc1">
                                                    <label htmlFor="first-name">RUT</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Código"
                                                            id="rfc1"
                                                            disabled={!editMode ? true : false}
                                                            value={updatebusinessPartner.LicTradNum || ""}
                                                            onBlur={this.ValidateLicTradNum}
                                                            onChange={(event) => this.ChangeLicTradNum(event.target.value)}
                                                        />
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                </div>
                                                <div className="form-group formulario__grupo" id="grupo__rfc1">
                                                    <p className="form__input-error" style={{ marginTop: "-14px" }}>{"Formato valido: (XAXX010101000)"}</p>
                                                    <p className="form__input-void" style={{ marginTop: "-14px" }}>RUT no puede ir vacio.</p>
                                                </div>
                                            </div>

                                            <div className="pr-3 col-12">
                                                <div className="form-group" id="grupo__fullName">
                                                    <div className="row">
                                                        <div className="col-md-1">
                                                            {/* <ToolTip tips={ToolTips.GeneralTips.RenameBP} position={'up'} /> */}


                                                        </div>
                                                        <div className="col-md-11">
                                                            <label className="row" htmlFor="full-name">
                                                                Nombre completo
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Nombre"
                                                            id="fullName"
                                                            name="fullName"
                                                            disabled={!editMode ? true : false}
                                                            value={updatebusinessPartner.U_FMB_AUX_CARDNAME || (updatebusinessPartner.CardName || "")}
                                                            onChange={(event) => this.ChangeCardName(event.target.value)}
                                                            onBlur={this.ValidateFullName}
                                                        />
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo letras, min 3 y max 200.</p>
                                                    <p className="form__input-void">Nombre no puede ir vacio.</p>
                                                </div>
                                            </div>

                                            {/* <div className={`pr-3 ${showPrioridadVta ? "col-6" : "col-12"}`}>
                                                <div className="form-group">
                                                    <label> Clasificación de cliente  </label>
                                                    <input
                                                        className="form-control"
                                                        disabled
                                                        value={updatebusinessPartner.U_Clasificacion || ""} />
                                                </div>
                                            </div>

                                            {showPrioridadVta &&
                                                <div className="pr-3 col-6">
                                                    <div className="form-group">
                                                        <label> Prioridad de venta  </label>
                                                        <select
                                                            className="form-control"
                                                            disabled={!Array.isArray(prioridadVtaCatalog)}
                                                            value={newOrderModel.U_PRIORIDADVTA || ""}
                                                            onChange={({ target: { value } }) => changeOrderField("U_PRIORIDADVTA", value)}>
                                                            <option value=""> Seleccionar prioridad </option>
                                                            {Array.isArray(prioridadVtaCatalog) ?
                                                                prioridadVtaCatalog.map(option => <option value={option.Code}> {option.Name} </option>) : <></>
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            } */}
                                        </div>
                                        <section>
                                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                                <li className="nav-item waves-effect waves-light">
                                                    <a className="nav-link active" id="account-tab" data-toggle="tab" href="#account" role="tab" aria-controls="account" aria-selected="false" style={{ color: "black" }} >
                                                        <h6>Cuenta</h6>
                                                    </a>
                                                </li>
                                                <li className="nav-item waves-effect waves-light">
                                                    <a className="nav-link" id="general-tab" data-toggle="tab" href="#generalInfo" role="tab" aria-controls="general" aria-selected="false" style={{ color: "black" }}>
                                                        <h6>Contacto</h6>
                                                    </a>
                                                </li>
                                                <li className="nav-item waves-effect waves-light">
                                                    <a className="nav-link" id="ingresos-tab" data-toggle="tab" href="#shippingAddress" role="tab" aria-controls="ingresos" aria-selected="true" style={{ color: "black" }}>
                                                        <h6>Dir. Envío</h6>
                                                    </a>
                                                </li>
                                                <li className="nav-item waves-effect waves-light">
                                                    <a className="nav-link" id="egresos-tab" data-toggle="tab" href="#billingAddress" role="tab" aria-controls="egresos" aria-selected="false" style={errorInTapBill == true ? { color: "red" } : { color: "black" }}>
                                                        <h6>Dir. Facturación</h6>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content" id="myTabContent" style={{ border: "1px solid #dee2e6", borderTop: "none", }}>
                                                {/* ------------------------------------- GENERAL --------------------------------------------------------- */}
                                                <div className="tab-pane fade" id="generalInfo" role="tabpanel" aria-labelledby="general-tab" style={{ maxHeight: "650px" }}>
                                                    <div className="row p-3">
                                                        <div className="col-12 pr-2">
                                                            <div className="scrollAddressDetails">
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <div className="input-group" style={{ width: "210px" }}>
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Teléfono:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        placeholder="Número de teléfono"
                                                                                        id="phone"
                                                                                        disabled={!editMode ? true : false}
                                                                                        value={updatebusinessPartner.Cellular || ""}
                                                                                        onChange={(event) => this.ChangeCellular(event.target.value)}
                                                                                        onBlur={this.ValidatePhone}
                                                                                    />
                                                                                </div>
                                                                                <div className="formulario__grupo" id="grupo__phone1">
                                                                                    <p className="form__input-error" style={{ marginTop: "-1px", color: "#6c757d" }}>{"Numero de telefono no valido."}</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Email:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        placeholder="Dirección de correo electrónico"
                                                                                        id="emailC"
                                                                                        disabled={!editMode ? true : false}
                                                                                        value={updatebusinessPartner.E_mail || ""}
                                                                                        onChange={(event) => this.ChangeE_mail(event.target.value)}
                                                                                        onBlur={this.ValidateEmail}
                                                                                    />
                                                                                </div>
                                                                                <div className="form-group formulario__grupo" id="grupo__emailC">
                                                                                    <p className="form__input-error" style={{ marginTop: "-1px", color: "#6c757d" }}>{"Dirección de correo no valida."}</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* ------------------------------------- ENVIO --------------------------------------------------------- */}
                                                <div className="tab-pane fade" id="shippingAddress" role="tabpanel">
                                                    {!showTemporalData &&
                                                        <div className="mt-4 ml-2 col-6">
                                                            <div className="form-group formulario__grupo" id="grupo__project">
                                                                <label htmlFor="first-name">Proyecto</label>
                                                                <div className="form__group-input">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form__input"
                                                                        placeholder=""
                                                                        id="project"
                                                                        disabled={true}
                                                                        readOnly={true}
                                                                        value={newOrderModel?.Project || ""}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {editMode && !showTemporalData &&
                                                        <button type="button" className="btn btn-outline-secondary mt-3 ml-3" onClick={() => DetailPartnerTools.NewAddress(1, false, 1)} style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right" }}>
                                                            <i className="fa fa-plus" aria-hidden="true" />
                                                        </button>
                                                    }
                                                    <div className="p-3">
                                                        {showTemporalData ?
                                                            <div className="pl-3 pr-3 scrollAddressDetails">
                                                                <form>
                                                                    <div className="row">
                                                                        <div className="col-12 pr-2 pl-2">
                                                                            <div className="form-group" id="grupo__firstName">
                                                                                <label htmlFor="firstName">Calle y Número</label>
                                                                                <div className="form__group-input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form__input"
                                                                                        placeholder="Calle y Número"
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.ShipToStreet : ""}
                                                                                        onChange={(event) => this.ChangeAddressStreet(event.target.value, "S")}
                                                                                    />
                                                                                    <i className="form__validation-state fa fa-times-circle" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-6 pr-2 pl-2">
                                                                            <div className="form-group formulario__grupo" id="grupo__cardCode">
                                                                                <label htmlFor="cardCode">Colonia</label>
                                                                                <div className="form__group-input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form__input"
                                                                                        placeholder="Colonia"
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.ShipToBlock : ""}
                                                                                        onChange={(event) => this.ChangeAddressBlock(event.target.value, "S")}
                                                                                    />
                                                                                    <i className="form__validation-state fa fa-times-circle" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6 pr-2 pl-2">
                                                                            <div className="form-group formulario__grupo" id="grupo__cardCode">
                                                                                <label htmlFor="cardCode">Ciudad</label>
                                                                                <div className="form__group-input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form__input"
                                                                                        placeholder="Ciudad"
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.ShipToCity : ""}
                                                                                        onChange={(event) => this.ChangeAddressCity(event.target.value, "S")}
                                                                                    />
                                                                                    <i className="form__validation-state fa fa-times-circle" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-6 pr-2 pl-2">
                                                                            <div className="form-group formulario__grupo" id="grupo__pc1">
                                                                                <label htmlFor="pc">Código postal</label>
                                                                                <div className="form__group-input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form__input"
                                                                                        placeholder="C.P."
                                                                                        id="pc1"
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.ShipToZipCode : ""}
                                                                                        onChange={(event) => this.ChangeAddressZipCode(event.target.value, "S")}
                                                                                        onBlur={this.ValidateZipCodeShip}
                                                                                    />
                                                                                    <i className="form__validation-state fa fa-times-circle"></i>
                                                                                </div>
                                                                                <div className="form-group formulario__grupo" id="grupo__pc1">
                                                                                    <p className="form__input-error" style={{ marginTop: "-1px" }}>{"Son 5 numeros"}</p>
                                                                                    <p className="form__input-void" style={{ marginTop: "-1px" }}>El no puede ir vació.</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-6 pr-2 pl-2">
                                                                            <div className="form-group formulario__grupo" id="grupo__state3" >
                                                                                <label htmlFor="pc">Estado </label>
                                                                                <div className="form__group-input">
                                                                                    <select
                                                                                        name="stateS"
                                                                                        className="form-control form__input"
                                                                                        id='state3'
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.ShipToState : ""}
                                                                                        onChange={(event) => this.ChangeAddressCounty(event.target.value, "S")}
                                                                                    >
                                                                                        <option value="---">Estado</option>
                                                                                        {states && states.length > 0 && states.map((state) => (
                                                                                            state.Country === "MX" ?
                                                                                                <option key={state.Code} value={state.Code} >
                                                                                                    {state.Name}
                                                                                                </option> : ""
                                                                                        ))}
                                                                                    </select>
                                                                                    <p className="form__input-void">Elija un estado.</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6 pr-2 pl-2">
                                                                            <div className="form-group formulario__grupo" id="grupo__rfc">
                                                                                <label htmlFor="pc">País </label>
                                                                                <div className="form__group-input">
                                                                                    <select
                                                                                        name="countryS"
                                                                                        className="form-control"
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.ShipToCountry : ""}
                                                                                        onChange={(event) => this.ChangeAddressCountry(event.target.value, "S")}
                                                                                    >
                                                                                        <option value="---">Pais</option>
                                                                                        {countries && countries.length > 0 && countries.map((country) => (
                                                                                            country.Name == "Mexico" ?
                                                                                                <option key={country.Code} value={country.Code}>
                                                                                                    {country.Name}
                                                                                                </option> : ""
                                                                                        ))}
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                            :
                                                            <div className="pl-2 pr-2 scrollAddressDetails">
                                                                {newOrderModel?.Items?.some(item => Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) && DetailPartnerTools?.deliveryAddresses?.length > 1 &&
                                                                    <div className="row m-0 p-0">
                                                                        <p className="m-0 p-0" style={{ fontSize: '13px', textAlign: "justify" }}><strong style={{ color: 'red' }}>Nota:</strong>Al cambiar la dirección, se consultarán automáticamente los precios de los artículos actuales.</p>
                                                                    </div>
                                                                }
                                                                {DetailPartnerTools && DetailPartnerTools.deliveryAddresses.map((address, index) => {
                                                                    let selectAddress = false;

                                                                    if (DetailPartnerTools.setDeliveryIndex === index) {
                                                                        selectAddress = true;
                                                                    } else if (address.Address === updatebusinessPartner.ShipToDef && DetailPartnerTools.setDeliveryIndex === "") {
                                                                        selectAddress = true;
                                                                        DetailPartnerTools.SetIndexDeliveryDirection(index, null, true)
                                                                    }
                                                                    return (
                                                                        <div className="card p-2 mt-2">
                                                                            <div className="row">
                                                                                <div className="col-2 p-3" onClick={() => DetailPartnerTools.SetIndexDeliveryDirection(index, address)}>
                                                                                    <input
                                                                                        type="radio"
                                                                                        checked={selectAddress}
                                                                                        style={{ margin: "15px" }}
                                                                                        disabled={actionButton ? false : editMode ? false : true}
                                                                                    />
                                                                                </div>
                                                                                <div className="col-8" onClick={() => DetailPartnerTools.SetIndexDeliveryDirection(index, address)} style={{ fontSize: "12px" }}>
                                                                                    <label>
                                                                                        <strong>{`${address.Address ?? ""}.`}</strong>
                                                                                    </label>
                                                                                    <p style={{ marginBottom: "2px" }}>
                                                                                        <strong>{`${address.Street ?? ""}`}</strong>
                                                                                        <br />
                                                                                        {`${address.Block ?? ""}. C.P.: ${address.ZipCode ?? ""} `}
                                                                                        <br />
                                                                                        {`${address.City ?? ""}. ${address.County ?? ""}. ${address.Country ?? ""} `}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="col-2">
                                                                                    <i className="fa fa-pencil-square-o" aria-hidden="true" data-dismiss={editMode === true ? "modal" : ""} style={editMode !== true ? { color: "#ccc" } : {}} onClick={editMode === true ? () => DetailPartnerTools.EditAddress(2, true, index, 1) : ""} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                {/* ------------------------------------- FACTURACION ----------------------------------------------- */}
                                                <div className="tab-pane fade" id="billingAddress" role="tabpanel">
                                                    {editMode && !showTemporalData &&
                                                        <button type="button" className="btn btn-outline-secondary mt-3 ml-3" onClick={() => DetailPartnerTools.NewAddress(1, false, 2)} style={{ backgroundColor: "#e9ecef", color: "#495057", border: "1px solid #ced4da", align: "right", }} >
                                                            <i className="fa fa-plus" aria-hidden="true" />
                                                        </button>
                                                    }
                                                    <div className="p-3">
                                                        {showTemporalData ?
                                                            <div className="pl-3 pr-3 scrollAddressDetails">
                                                                <form>
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <div className="form-group" id="grupo__street2" >
                                                                                <label htmlFor="street2">
                                                                                    Calle y Número
                                                                                </label>
                                                                                <div className="form__group-input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form__input"
                                                                                        placeholder="Calle y Número"
                                                                                        id="street2"
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.BillToStreet : ""}
                                                                                        onChange={(event) => this.ChangeAddressStreet(event.target.value, "B")}
                                                                                        onBlur={this.ValidateStreet}
                                                                                    />
                                                                                    <i className="form__validation-state fa fa-times-circle" />
                                                                                </div>
                                                                                <div className="form-group formulario__grupo" id="grupo__street2">
                                                                                    <p className="form__input-error" style={{ marginTop: "-1px" }}>{"ALGO calle"}</p>
                                                                                    <p className="form__input-void" style={{ marginTop: "-1px" }}>No puede ir vacio.</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-6">
                                                                            <div className="form-group formulario__grupo" id="grupo__block2" >
                                                                                <label htmlFor="cardCode">Colonia</label>
                                                                                <div className="form__group-input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form__input"
                                                                                        placeholder="Colonia"
                                                                                        id="block2"
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.BillToBlock : ""}
                                                                                        onChange={(event) => this.ChangeAddressBlock(event.target.value, "B")}
                                                                                        onBlur={this.ValidateBlock}
                                                                                    />
                                                                                    <i className="form__validation-state fa fa-times-circle" />
                                                                                </div>
                                                                                <div className="form-group formulario__grupo" id="grupo__block2">
                                                                                    <p className="form__input-error" style={{ marginTop: "-1px" }}>{"ALGO calle"}</p>
                                                                                    <p className="form__input-void" style={{ marginTop: "-1px" }}>No puede ir vació.</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <div className="form-group formulario__grupo" id="grupo__city2" >
                                                                                <label htmlFor="cardCode">Ciudad</label>
                                                                                <div className="form__group-input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form__input"
                                                                                        placeholder="Ciudad"
                                                                                        id="city2"
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.BillToCity : ""}
                                                                                        onChange={(event) => this.ChangeAddressCity(event.target.value, "B")}
                                                                                        onBlur={this.ValidateCity}
                                                                                    />
                                                                                    <i className="form__validation-state fa fa-times-circle" />
                                                                                </div>
                                                                                <div className="form-group formulario__grupo" id="grupo__city2">
                                                                                    <p className="form__input-error" style={{ marginTop: "-1px" }}>{"ALGO ciudad"}</p>
                                                                                    <p className="form__input-void" style={{ marginTop: "-1px" }}>No puede ir vacio.</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-6 pr-2 pl-2">
                                                                            <div className="form-group formulario__grupo" id="grupo__pc2">
                                                                                <label htmlFor="pc2">Código postal</label>
                                                                                <div className="form__group-input">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form__input"
                                                                                        placeholder="C.P."
                                                                                        id="pc2"
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.BillToZipCode : ""}
                                                                                        onChange={(event) => this.ChangeAddressZipCode(event.target.value, "B")}
                                                                                        onBlur={this.ValidateZipCodeBill}
                                                                                    />
                                                                                    <i className="form__validation-state fa fa-times-circle"></i>
                                                                                </div>
                                                                                <div className="form-group formulario__grupo" id="grupo__pc2">
                                                                                    <p className="form__input-error" style={{ marginTop: "-1px" }}>{"Son 5 números"}</p>
                                                                                    <p className="form__input-void" style={{ marginTop: "-1px" }}>No puede ir vacio.</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-6" id="grupo__state2" >
                                                                            <div className="form-group form__group-input">
                                                                                <label htmlFor="state2">Estado </label>
                                                                                <select
                                                                                    name="stateB"
                                                                                    className="form-control form__input"
                                                                                    id='state2'
                                                                                    onChange={(event) => this.ChangeAddressCounty(event.target.value, "B")}
                                                                                    value={newOrderModel?.AddressExtension?.BillToState ?? ''}
                                                                                    onBlur={this.ValidateState}
                                                                                >
                                                                                    <option value="">Estado</option>
                                                                                    {states && states.length > 0 && states.map((state) => (
                                                                                        state.Country === "MX" ?
                                                                                            <option key={state.Code} value={state.Code}>
                                                                                                {state.Name}
                                                                                            </option> : ""
                                                                                    ))}
                                                                                </select>
                                                                                <p className="form__input-void">Elija un estado.</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6">
                                                                            <div className="form-group formulario__grupo" id="grupo__rfc" >
                                                                                <label htmlFor="pc">País </label>
                                                                                <div className="form__group-input">
                                                                                    <select
                                                                                        name="countryB"
                                                                                        value={newOrderModel.AddressExtension ? newOrderModel.AddressExtension.BillToCountry : ""}
                                                                                        className="form-control"
                                                                                        onChange={(event) => this.ChangeAddressCountry(event.target.value, "B")}>
                                                                                        <option value="---">Pais</option>
                                                                                        {countries && countries.length > 0 && countries.map((country) => (
                                                                                            <option key={country.Code} value={country.Code} >
                                                                                                {country.Name}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                            :
                                                            <div className="pl-2 pr-2 scrollAddressDetails">
                                                                {DetailPartnerTools && DetailPartnerTools.billAddresses.map((address, index) => {
                                                                    let selectAddress = false;
                                                                    if (DetailPartnerTools.setBillIndex === index) {
                                                                        selectAddress = true;
                                                                    } else if (address.Address === updatebusinessPartner.BillToDef && DetailPartnerTools.setBillIndex === "") {
                                                                        DetailPartnerTools.SetIndexBillDirection(index, address)
                                                                        selectAddress = true;
                                                                    }
                                                                    return (
                                                                        <div className="card p-2 mt-2">
                                                                            <div className="row">
                                                                                <div className="col-2 p-3" onClick={() => DetailPartnerTools.SetIndexBillDirection(index, address)}>
                                                                                    <input
                                                                                        type="radio"
                                                                                        checked={selectAddress}
                                                                                        style={{ margin: "15px" }}
                                                                                        disabled={actionButton ? false : editMode ? false : true} />
                                                                                </div>
                                                                                <div className="col-8" onClick={() => DetailPartnerTools.SetIndexBillDirection(index, address)} style={{ fontSize: "12px" }}>
                                                                                    <label>
                                                                                        <strong>{`${address.Address ?? ""}.`}</strong>
                                                                                    </label>
                                                                                    <p style={{ marginBottom: "2px" }}>
                                                                                        <strong>{`${address.Street ?? ""}`}</strong>
                                                                                        <br />
                                                                                        {`${address.Block ?? ""}. C.P.: ${address.ZipCode ?? ""} `}
                                                                                        <br />
                                                                                        {`${address.City ?? ""}. ${address.County ?? ""}. ${address.Country ?? ""} `}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="col-2">
                                                                                    <i className="fa fa-pencil-square-o" aria-hidden="true" style={editMode !== true ? { color: "#ccc" } : {}} onClick={editMode === true ? () => DetailPartnerTools.EditAddress(2, true, index, 2) : ""} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                {/* ------------------------------------------ CUENTA ----------------------------------------------- */}
                                                <div className="tab-pane fade active show" id="account" role="tabpanel">
                                                    <div className="row p-3">
                                                        <div className="col-12 pr-2">
                                                            <div className="scrollAddressDetails">
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group ">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Monto vencido:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id="accMontoVencido"
                                                                                        disabled="true"
                                                                                        value={CURRENCY + ' ' + FORMAT_NUMBER.new(updatebusinessPartner.MontoVencido || 0)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Total Facturado: </strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id="accFacturado"
                                                                                        disabled="true"
                                                                                        value={CURRENCY + ' ' + FORMAT_NUMBER.new(updatebusinessPartner.Facturado || 0)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>
                                                                                                Crédito disponible
                                                                                            </strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id="creditDays"
                                                                                        disabled="true"
                                                                                        value={CURRENCY + ' ' + FORMAT_NUMBER.new(updatebusinessPartner.Disponible || 0)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Documentos vencidos: </strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id="accDocsVencidos"
                                                                                        disabled="true"
                                                                                        value={updatebusinessPartner.DocsVencidos || ""}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Condiciones de pago:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <select
                                                                                        name="select"
                                                                                        className="form-control"
                                                                                        id="selectProject"
                                                                                        disabled//={!editMode ? true : false}
                                                                                        value={updatebusinessPartner.GroupNum || ""}
                                                                                    // onChange={(event) => this.ChangeGroupNum(event.target.value, event)}
                                                                                    >
                                                                                        <option value="">Seleccionar</option>
                                                                                        {GroupNumList && GroupNumList.map((groupNum) => {
                                                                                            return (
                                                                                                <option value={groupNum.GroupNum}>{groupNum.PymntGroup}</option>
                                                                                            );
                                                                                        })}
                                                                                    </select>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Días de crédito: </strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        placeholder="Días de crédito"
                                                                                        id="creditDays"
                                                                                        disabled={true}
                                                                                        value={updatebusinessPartner.ExtraDays || ""}
                                                                                        onChange={(event) => this.ChangeExtraDays(event.target.value)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            </tr>
                                                                            <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Crédito:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        placeholder="Límite de crédito"
                                                                                        id="limit"
                                                                                        disabled//={!editMode ? true : false}
                                                                                        value={updatebusinessPartner?.CreditLine ?? "0.00"}
                                                                                    // onBlur = {() => this.ValidateCreditLine()}
                                                                                    // onChange={(event) => this.ChangeCreditLine(event.target.value)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        {/* <tr>
                                                                            <td colSpan={2}>
                                                                                <div id="grupo__selectProject1">
                                                                                    <div className="input-group mt-3" >
                                                                                        <div className="input-group-prepend">
                                                                                            <span className="input-group-text">
                                                                                                <strong>Uso de CFDI:</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                        <select
                                                                                            name="select"
                                                                                            className="form-control"
                                                                                            id="selectProject"
                                                                                            disabled={!editMode ? true : false}
                                                                                            value={newOrderModel.USOCFDI || ""}
                                                                                            onChange={(event) => ChangeUSOCFDI(event.target.value)}
                                                                                            onBlur={this.ValidateUCFDI}
                                                                                        >
                                                                                            <option value="">Seleccionar</option>
                                                                                            {CFDI && CFDI.map((cfdi) => {
                                                                                                return (
                                                                                                    <option value={cfdi.FldValue}>{cfdi.Descr}</option>
                                                                                                );
                                                                                            })}
                                                                                        </select>

                                                                                    </div>
                                                                                    <p className="form__input-error" style={{ marginTop: "-1px", color: "#6c757d" }}>{"No ha seleccionado nada."}</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr> */}
                                                                        {/* <tr>
                                                                            <td colSpan={2}>
                                                                                <div id="grupo__taxSystem">
                                                                                    <div className="input-group mt-3">
                                                                                        <div className="input-group-prepend">
                                                                                            <span className="input-group-text">
                                                                                                <strong>Regimen fiscal:</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                        <select
                                                                                            name="select"
                                                                                            className="form-control"
                                                                                            id="taxSystem"
                                                                                            disabled={!editMode ? true : false}
                                                                                            value={newOrderModel.RegimenFiscal || ""}
                                                                                            onChange={(event) => ChangeRegimenFiscal(event.target.value)}
                                                                                            onBlur={this.ValidateTaxSystem}
                                                                                        >
                                                                                            <option value="">Seleccionar</option>
                                                                                            {RegimenFiscal && RegimenFiscal.map((regimenFiscal) => {
                                                                                                return (
                                                                                                    <option value={regimenFiscal.FldValue}>{regimenFiscal.Descr}</option>
                                                                                                );
                                                                                            })}
                                                                                        </select>
                                                                                    </div>
                                                                                    <p className="form__input-error" style={{ marginTop: "-1px", color: "#6c757d" }}>{"No ha seleccionado nada."}</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Método de pago:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <select
                                                                                        name="select"
                                                                                        className="form-control"
                                                                                        id="typeOfRelation"
                                                                                        disabled={(creditCondition || view === 'rePrint' || newOrderModel.ObjType === 'deliveries2') ? true : false}
                                                                                        value={creditCondition || view === 'rePrint' ? 'PUE' : newOrderModel.U_SO1_02METODOPAGO || ""}
                                                                                        onChange={(event) => creditCondition || view === 'rePrint' ? '' : Change_MetodoPago(event.target.value)}
                                                                                    >
                                                                                        <option value="">-Selecciona-</option>
                                                                                        <option value="PUE">Pago en una exhibición</option>
                                                                                        <option value="PPD" disabled={updatebusinessPartner.GroupNum === '-1' ? true : false}>Pago en parcialidades o diferido</option>
                                                                                    </select>
                                                                                </div>


                                                                            </td>
                                                                        </tr> */}
                                                                        {/* Mostrar método de pago solo si no es refacturación*/}
                                                                        {/* {(view !== 'rePrint') &&
                                                                            <tr>
                                                                                <td colSpan={2}>
                                                                                    <div className="input-group mt-3">
                                                                                        <div className="input-group-prepend">
                                                                                            <span className="input-group-text">
                                                                                                <strong>Forma de pago:</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                        <select
                                                                                            name="select"
                                                                                            className="form-control"
                                                                                            id="typeOfRelation"
                                                                                            disabled={newOrderModel.U_SO1_02METODOPAGO === 'PPD'}
                                                                                            value={newOrderModel.U_SO1_02FORMAPAGO || ""}
                                                                                            onChange={(event) => Change_FormaPago(event.target.value)}
                                                                                        >
                                                                                            <option value="">-Selecciona-</option>
                                                                                            <option value="01">Efectivo</option>
                                                                                            <option value="02">Cheque nominativo</option>
                                                                                            <option value="03">Transferencia electrónica de fondos</option>
                                                                                            <option value="04">Tarjeta de crédito</option>
                                                                                            <option value="05">Monedero electrónico</option>
                                                                                            <option value="06">Dinero electrónico</option>
                                                                                            <option value="08">Vales de despensa</option>
                                                                                            <option value="12">Dación en pago</option>
                                                                                            <option value="13">Pago por subrogación</option>
                                                                                            <option value="14">Pago por consignación</option>
                                                                                            <option value="15">Condonación</option>
                                                                                            <option value="17">Compensación</option>
                                                                                            <option value="23">Novación</option>
                                                                                            <option value="24">Confusión</option>
                                                                                            <option value="25">Remisión de deuda</option>
                                                                                            <option value="26">Prescripción o caducidad</option>
                                                                                            <option value="27">A satisfacción del acreedor</option>
                                                                                            <option value="28">Tarjeta de débito</option>
                                                                                            <option value="29">Tarjeta de servicios</option>
                                                                                            <option value="30">Aplicación de anticipos</option>
                                                                                            <option value="31">Intermediario pagos</option>
                                                                                            <option value="99">Por definir</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>} */}
                                                                        {/* UUID RELACIONADO*/}
                                                                        {/* {(view !== 'rePrint') &&
                                                                            <tr>
                                                                                <td colSpan={2}>
                                                                                    <div className="input-group mt-3">
                                                                                        <div className="input-group-prepend">
                                                                                            <span className="input-group-text" style={{ width: '100%' }}>
                                                                                                <strong>UUID RELACIONADO:</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                        <input
                                                                                            style={{
                                                                                                width: '100%',
                                                                                                important: true,
                                                                                                backgroundColor: 'transparent',
                                                                                                borderColor: '#ced4da',
                                                                                                color: '#000',
                                                                                            }}
                                                                                            type="text"
                                                                                            maxLength='36'
                                                                                            className="form-control"
                                                                                            id="txtStatus"
                                                                                            autoComplete="off"
                                                                                            onKeyDown={(e) => {
                                                                                                if (e.key === ' ') e.preventDefault();
                                                                                            }}
                                                                                            // disabled="true"
                                                                                            value={newOrderModel?.UUID_RELACIONADO ?? ''}
                                                                                            // onBlur={(event) => this.ValidateOfUUIDRelation(event.target.value)}
                                                                                            onChange={(event) => ChangeOfUUIDRelation(event.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        } */}
                                                                        {/* <tr>
                                                                            <td colSpan={2}>
                                                                                <div id="grupo__typeOfRelation">
                                                                                    <div className="input-group mt-3">
                                                                                        <div className="input-group-prepend">
                                                                                            <span className="input-group-text">
                                                                                                <strong>Tipo relación CFDI:</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                        <select
                                                                                            name="select"
                                                                                            className="form-control"
                                                                                            id="typeOfRelation"
                                                                                            value={newOrderModel.U_FMB_TIPO_REL || ""}
                                                                                            onChange={(event) => Change_Tipo_Relacion_CFDI(event.target.value)}
                                                                                            onBlur={this.ValidateTypeOfRelation}
                                                                                        >
                                                                                            <option value="00">No aplica</option>
                                                                                            <option value="01">01-Nota de crédito de los documentos relacionados</option>
                                                                                            <option value="02">02-Nota de débito de los documentos relacionados</option>
                                                                                            <option value="03">03-Devolución de mercancía sobre facturas o traslados previos</option>
                                                                                            <option value="04">04-Sustitución de los CFDI previos</option>
                                                                                            <option value="05">05-Traslados de mercancías facturados previamente</option>
                                                                                            <option value="06">06-Factura generada por los traslados previos</option>
                                                                                            <option value="07">07-CFDI por aplicación de anticipo</option>
                                                                                        </select>
                                                                                    </div>
                                                                                    <p className="form__input-error" style={{ marginTop: "-1px", color: "#6c757d" }}>{"No ha seleccionado nada."}</p>
                                                                                </div>
                                                                            </td>
                                                                        </tr> */}
                                                                        {/* <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>
                                                                                                Folio fiscal relacionado:
                                                                                            </strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id="uuid_Related"
                                                                                        onChange={(event) => this.ChangeU_FMB_UUID_RELACIONADO(event.target.value)}
                                                                                        value={newOrderModel.U_FMB_UUID_RELACIONADO ?? ''}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr> */}
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3" >
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text font-weight-bold"> Detracción: </span>
                                                                                    </div>
                                                                                    <input
                                                                                        className="form-control"
                                                                                        value={newOrderModel.U_STR_AfctoDtr || ""}
                                                                                        onChange={({ target: { value } }) => changeOrderField("U_STR_AfctoDtr", value, 1)} />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3" >
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text font-weight-bold"> Cod. Bien o Servicio: </span>
                                                                                    </div>
                                                                                    <input
                                                                                        className="form-control"
                                                                                        value={newOrderModel.U_STR_CodBnSs || ""}
                                                                                        onChange={({ target: { value } }) => changeOrderField("U_STR_CodBnSs", value, 10)} />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3" >
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text font-weight-bold"> Tasa de Detracción: </span>
                                                                                    </div>
                                                                                    <input
                                                                                        className="form-control"
                                                                                        value={newOrderModel.U_STR_TazaDtr || ""}
                                                                                        onChange={({ target: { value } }) => { if (!isNaN(value) && Number(value || 0) <= 100 ) { changeOrderField("U_STR_TazaDtr", value); } }}
                                                                                        onBlur={() => { let value = newOrderModel.U_STR_TazaDtr; if (!isNaN(value) && Number(value || 0) <= 100 ) { value = Number(value || 0).toFixed(2) } else { value = ""; } changeOrderField("U_STR_TazaDtr", value); }} />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </form>
                                    <div className='row'>

                                        {(!!RecoverDoc) ?
                                            (RecoverDoc === false) ?
                                                (editMode && view !== 'rePrint') ?
                                                    <div className="col-12 text-right">
                                                        <label className="mr-3">
                                                            Datos temporales
                                                        </label>
                                                        <label className="switch mt-3 mr-4" >
                                                            <input type="checkbox"
                                                                // disabled={showTemporalData ? false : true}
                                                                checked={showTemporalData ? showTemporalData : false}
                                                                onChange={ChangeShowTemporalData}
                                                            />
                                                            <span className="sliderDC round"></span>
                                                        </label>
                                                    </div>
                                                    :
                                                    ""
                                                :
                                                ""
                                            :
                                            (editMode && view !== 'rePrint') ?
                                                <div className="col-12 text-right">
                                                    <label className="mr-3">
                                                        Datos temporales
                                                    </label>
                                                    <label className="switch mt-3 mr-4" >
                                                        <input type="checkbox"
                                                            // disabled={showTemporalData ? false : true}
                                                            checked={showTemporalData ? showTemporalData : false}
                                                            onChange={ChangeShowTemporalData}
                                                        />
                                                        <span className="sliderDC round"></span>
                                                    </label>
                                                </div>
                                                : ""
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="container-fluid">
                                    <div className="row">

                                        { // leer los comentarios en orden de else if sintaxis para entenderlos mejor como ternaria 
                                            (!!RecoverDoc) ? // si existe la variable para un documento recuperado 
                                                (RecoverDoc === false) ?  // valida el camino con esa variable y que no muestre el botón de cancelar 
                                                    editMode && showTemporalData &&
                                                    <>
                                                        <div className="col-6 col-sm-4 mb-2 mb-sm-0">
                                                            <button type="button" className="btn btn-secondary btn-block btn-lg" onClick={() => this.ResetValidations(EditBusinessPartner)}>
                                                                Cancelar
                                                            </button>
                                                        </div>
                                                        <div className="col-6 col-sm-8">
                                                            <button type="button" className="btn btn-primary btn-block btn-lg" onClick={() => this.ValidateAll(() => ContinueWithoutSave(), true)}>
                                                                Continuar
                                                            </button>
                                                        </div>
                                                    </>
                                                    : // si es true que siga su camino normal
                                                    editMode && showTemporalData &&
                                                    <>
                                                        <div className="col-6 col-sm-8">
                                                            <button type="button" className="btn btn-primary btn-block btn-lg" onClick={() => this.ValidateAll(() => ContinueWithoutSave(), true)}>
                                                                Continuar
                                                            </button>
                                                        </div>
                                                    </>
                                                :
                                                editMode && showTemporalData && // si no existió la variable es como si no tocáramos nada 
                                                <>
                                                    <div className="col-6 col-sm-4 mb-2 mb-sm-0">
                                                        <button type="button" className="btn btn-secondary btn-block btn-lg" onClick={() => this.ResetValidations(EditBusinessPartner)}>
                                                            Cancelar
                                                        </button>
                                                    </div>
                                                    <div className="col-6 col-sm-8">
                                                        <button type="button" className="btn btn-primary btn-block btn-lg" onClick={() => this.ValidateAll(() => ContinueWithoutSave(), true)}>
                                                            Continuar
                                                        </button>
                                                    </div>
                                                </>
                                        }
                                        {editMode && !showTemporalData &&
                                            <>
                                                <div className="col-6 col-sm-4 mb-2 mb-sm-0">
                                                    <button type="button" className="btn btn-secondary btn-block btn-lg" onClick={() => this.ResetValidations(EditBusinessPartner)}>
                                                        Cancelar
                                                    </button>
                                                </div>
                                                <div className="col-6 col-sm-8">
                                                    <button type="button" className="btn btn-primary btn-block btn-lg" onClick={() => this.ValidateAll(() => UpdateBusinessPartner(), true)}>
                                                        Guardar
                                                    </button>
                                                </div>
                                            </>
                                        }
                                        {!editMode &&
                                            <>
                                                <div className="col-6 col-sm-4 mb-2 mb-sm-0">
                                                    <button type="button" className="btn btn-secondary btn-block btn-lg" data-dismiss="modal" data-target={actionButton ? `#${DetailPartnerTools.FlowOrigin}` : "#clientsModal"} data-toggle="modal">
                                                        Cerrar
                                                    </button>
                                                </div>
                                                <div className={actionButton ? "col-6 col-sm-4 mb-2 mb-sm-0" : "col-6 col-sm-8"}>
                                                    <button type="button" className={actionButton ? "btn btn-secondary btn-block btn-lg" : "btn btn-primary btn-block btn-lg"} onClick={EditBusinessPartner}>
                                                        Editar
                                                    </button>
                                                </div>
                                                {actionButton &&
                                                    <div className="col-6 col-sm-4">
                                                        <button type="button" className="btn btn-primary btn-block btn-lg" onClick={() => this.ValidateAddressList(NextStepFunction)}>
                                                            Continuar
                                                        </button>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <NewAddressModal DetailPartnerTools={DetailPartnerTools} states={states} countries={countries} />
            </div>
        );
    }
}

export default DetailClientModal;
